import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
class Report {
  static dsn = 'https://afacf89b33d64e049daccd216f936a39@sentry.westartrack.com/4'
  constructor (Vue, options = {}) {
    console.log('log.js', process.env)
    if (process.env.NODE_ENV === 'production') {
      // TODO
    }
    this.Vue = Vue
    this.options = options
  }
  /**
   * 单例模式
   */
  static getInstance (Vue, options) {
    if (!(this.instance instanceof this)) {
      this.instance = new this(Vue, options)
      if (process.env.NODE_ENV === 'production') {
        this.instance.install()
        this.instance.registerError()
      }
    }
    return this.instance
  }
  /**
   * init
   */
  install () {
    console.log(process.env)
    Sentry.init({
      dsn: 'https://afacf89b33d64e049daccd216f936a39@sentry.westartrack.com/4',
      integrations: [new Integrations.Vue({ Vue, attachProps: true })],
      logErrors: true,
      release: process.env.RELEASE_VERSION, // 版本号
      // release: process.env.npm_pacakage_version,
      environment: process.env.ENV_TYPE || 'development',
      onerror: true,
      onunhandledrejection: true
    })
    // 设置全局tag标签
  }
  setUser (auth, baseinfo = {}) {
    // 记录用户信息
    Sentry.setUser({
      // user: auth,
      userid: baseinfo.userid,
      username: baseinfo.username,
      system_role: baseinfo.system_role,
      vip: baseinfo.vip
    })
  }
  /**
   * 注册全局错误处理
   */
  registerError () {
    // 监听error
    window.onerror = (msg, url, line, col, error) => {
      console.log('onerror')
      if (msg !== 'Script error.' && !url) {
        return true
      }
      setTimeout(() => {
        let data = {}
        col = col || (window.event && window.event.errorCharacter) || 0
        data.url = url
        data.line = line
        data.col = col
        data.error = error
        if (error && error.stack) {
          data.msg = error.stack.toString()
        }
        this.log(JSON.stringify(data))
      }, 0)
      return true
    }

    // 监听promise
    window.addEventListener('unhandledrejection', err => {
      console.log('unhandledrejection')
      setTimeout(() => {
        this.log(JSON.stringify(err))
      }, 0)
    })

    // addEventListener捕获网络请求错误
    window.addEventListener(
      'error',
      e => {
        e.stopImmediatePropagation()
        const srcElement = e.srcElement
        if (srcElement === window) {
          // 全局错误
          console.log('全局错误')
          console.log('message', e.message)
          this.log(JSON.stringify(e))
        } else {
          // 元素错误，比如引用资源报错
          console.log('元素错误')
          console.log('tagname', srcElement.tagName)
          console.log('src', srcElement.src)

          this.log({
            message: '元素错误',
            tagname: srcElement.tagName,
            src: srcElement.src
          })
        }
        console.log('onerror捕获网络请求错误', e) // 捕获错误
      },
      true // 网络错误，在捕获阶段获取，第三个参数为true
    )

    // 对网页中每一个对象（脚本文件、样式表、图片文件等等）发出一个HTTP请求
    if (window.performance && window.performance.getEntries) {
      let performanceResult = []
      // 获取当前页面所有请求对应的PerformanceResourceTiming对象进行分析
      window.performance.getEntries().forEach(item => {
        if (item.duration > 1000) {
          Sentry.addBreadcrumb({
            category: 'manual message',
            message: '此资源加载速度慢',
            level: 'info'
          })
        }

        performanceResult.push({
          url: item.name,
          entryType: item.entryType,
          type: item.initiatorType,
          'duration(ms)': item.duration
        })
      })

      // 控制台输出统计结果
      // console.table(performanceResult)
      window.onload = () => {
        let times = this.getPerformanceTiming()
        let keys = {
          loadPage: '用户等待页面可用的时间,onload时间(总下载时间)',
          domReady: 'domready时间(用户可操作时间节点)',
          redirect: '重定向的时间',
          lookupDomain: 'DNS查询耗时',
          ttfb: '白屏时间',
          request: 'request请求耗时',
          loadEvent: '执行 onload 回调函数的时间',
          appcache: 'DNS 缓存时间',
          unloadEvent: '卸载页面的时间',
          connect: 'TCP链接耗时'
        }
        /* 常用计算：
        DNS查询耗时 ：domainLookupEnd - domainLookupStart
        TCP链接耗时 ：connectEnd - connectStart
        request请求耗时 ：responseEnd - responseStart
        解析dom树耗时 ： domComplete - domInteractive
        白屏时间 ：responseStart - navigationStart
        domready时间(用户可操作时间节点) ：domContentLoadedEventEnd - navigationStart
        onload时间(总下载时间) ：loadEventEnd - navigationStart */
        let timesText = {}
        for (let i in keys) {
          for (let j in times) {
            if (i === j) {
              timesText[keys[i]] = times[j]
            }
          }
        }
        Sentry.setExtra('times', timesText)
      }
    }
  }
  /**
   * 主动上报
   * type: 'info','warning','error'
   */
  log (data = null, extra = {}) {
    let type = extra.type || 'error'
    let message = ''
    if (typeof data === 'object') {
      message = data.message
    } else if (typeof data === 'string') {
      message = data
    }
    if (Object.keys(extra).length) {
      Sentry.setExtra('response', data)
      Sentry.setExtra('headers', extra.headers)
      Sentry.setExtra('request', extra.request)
      Sentry.setExtra('config', extra.config)
      if (extra.config && extra.config.url) {
        Sentry.setTag('api', extra.config.url)
      }
    }
    // 添加面包屑
    /* Sentry.addBreadcrumb({
      category: 'manual message',
      message: data,
      level: type
    }) */
    // 异常上报
    if (data instanceof Error) {
      Sentry.captureException(data, {
        level: type,
        logger: 'manual exception'
        // tags: { options: options }
      })
    } else {
      Sentry.captureException(message, {
        level: type,
        logger: 'manual exception'
      })
    }
  }
  // 计算加载时间
  getPerformanceTiming () {
    var performance = window.performance

    if (!performance) {
      // 当前浏览器不支持
      console.log('你的浏览器不支持 performance 接口')
      return
    }

    var t = performance.timing
    var times = {}

    // 【重要】页面加载完成的时间
    // 【原因】这几乎代表了用户等待页面可用的时间
    times.loadPage = t.loadEventEnd - t.navigationStart

    // 【重要】解析 DOM 树结构的时间
    // 【原因】反省下你的 DOM 树嵌套是不是太多了！
    times.domReady = t.domComplete - t.responseEnd

    // 【重要】重定向的时间
    // 【原因】拒绝重定向！比如，http://example.com/ 就不该写成 http://example.com
    times.redirect = t.redirectEnd - t.redirectStart

    // 【重要】DNS 查询时间
    // 【原因】DNS 预加载做了么？页面内是不是使用了太多不同的域名导致域名查询的时间太长？
    // 可使用 HTML5 Prefetch 预查询 DNS ，见：[HTML5 prefetch](http://segmentfault.com/a/1190000000633364)
    times.lookupDomain = t.domainLookupEnd - t.domainLookupStart

    // 【重要】读取页面第一个字节的时间
    // 【原因】这可以理解为用户拿到你的资源占用的时间，加异地机房了么，加CDN 处理了么？加带宽了么？加 CPU 运算速度了么？
    // TTFB 即 Time To First Byte 的意思
    // 维基百科：https://en.wikipedia.org/wiki/Time_To_First_Byte
    times.ttfb = t.responseStart - t.navigationStart

    // 【重要】内容加载完成的时间
    // 【原因】页面内容经过 gzip 压缩了么，静态资源 css/js 等压缩了么？
    times.request = t.responseEnd - t.requestStart

    // 【重要】执行 onload 回调函数的时间
    // 【原因】是否太多不必要的操作都放到 onload 回调函数里执行了，考虑过延迟加载、按需加载的策略么？
    times.loadEvent = t.loadEventEnd - t.loadEventStart

    // DNS 缓存时间
    times.appcache = t.domainLookupStart - t.fetchStart

    // 卸载页面的时间
    times.unloadEvent = t.unloadEventEnd - t.unloadEventStart

    // TCP 建立连接完成握手的时间
    times.connect = t.connectEnd - t.connectStart

    return times
  }
  /* log (data = null, type = 'error', options = {}) {

    // 添加面包屑
    Sentry.addBreadcrumb({
      category: 'manual message',
      message: data,
      level: 'info'
    })
    // 异常上报
    if (data instanceof Error) {
      Sentry.captureException(data, {
        level: type,
        logger: 'manual exception',
        tags: { options: options }
      })
    } else if (typeof data === 'object') {
      Sentry.captureException(JSON.stringify(data))
      Sentry.withScope((scope) => {
        // 设置附加数据：
        scope.setExtra('error', { data })
      })
    } else if (typeof data === 'string') {
      Sentry.captureException(data)
    }
  } */
}
export default Report
